var map = {
	"./Analytics": 721,
	"./Analytics.js": 721,
	"./Links.html": 1524,
	"./Robots.txt": 1525,
	"./TagManager": 722,
	"./TagManager.js": 722,
	"./Wayfinder": 723,
	"./Wayfinder.js": 723,
	"./favicon.ico": 1526,
	"./google59e421ebfe8a8015.html": 1527,
	"./im.html": 1528,
	"./images/2023-og-image-klo.jpg": 1529,
	"./images/Allissue.PNG": 1530,
	"./images/Arrow-Right.PNG": 1531,
	"./images/CYB2.jpg": 1532,
	"./images/Fullissue.PNG": 1533,
	"./images/Home-Help-mousehover.png": 1534,
	"./images/Home-Help.png": 1535,
	"./images/Home-search-mousehover.png": 1536,
	"./images/Home-search.png": 1537,
	"./images/List-Style.PNG": 1538,
	"./images/NextArticle.PNG": 1539,
	"./images/Outlook-WK.jpg": 1540,
	"./images/Plus.PNG": 1541,
	"./images/Rss-Default.png": 1542,
	"./images/Rss-Hover.png": 1543,
	"./images/WK.PNG": 1544,
	"./images/WkFooter.PNG": 1545,
	"./images/ajax-loader.gif": 1546,
	"./images/amex.png": 1547,
	"./images/arrow_down.png": 1548,
	"./images/arrow_up.png": 1549,
	"./images/authorSpotlight/adamLiberman.jpg": 1550,
	"./images/authorSpotlight/alanChristopherNeal.jpg": 1551,
	"./images/authorSpotlight/alastairSutton.jpg": 1552,
	"./images/authorSpotlight/albertJanVanDenBerg.jpg": 1553,
	"./images/authorSpotlight/alexanderRust.jpg": 1554,
	"./images/authorSpotlight/andreAlen.jpg": 1555,
	"./images/authorSpotlight/andreaBiondi.jpg": 1556,
	"./images/authorSpotlight/andreasRZiegler.jpg": 1557,
	"./images/authorSpotlight/author-Esme.png": 1558,
	"./images/authorSpotlight/author-roger.png": 1559,
	"./images/authorSpotlight/author-spot1.png": 1560,
	"./images/authorSpotlight/berntHugenholtz.jpg": 1561,
	"./images/authorSpotlight/bobWessels.jpg": 1562,
	"./images/authorSpotlight/edwinVermulst.jpg": 1563,
	"./images/authorSpotlight/ericSchwartz.jpg": 1564,
	"./images/authorSpotlight/frankEijsvogels.jpg": 1565,
	"./images/authorSpotlight/frankHendrickx.jpg": 1566,
	"./images/authorSpotlight/garyBorn.jpg": 1567,
	"./images/authorSpotlight/jeanFrancoisBelis.jpg": 1568,
	"./images/authorSpotlight/jeffreyLSnyder.jpg": 1569,
	"./images/authorSpotlight/jochenBuling.jpg": 1570,
	"./images/authorSpotlight/jochenBühling.jpg": 1571,
	"./images/authorSpotlight/jochenB├╝hling.jpg": 1572,
	"./images/authorSpotlight/johannMuller.jpg": 1573,
	"./images/authorSpotlight/johnBalfour.jpg": 1574,
	"./images/authorSpotlight/jonathanSLux.jpg": 1575,
	"./images/authorSpotlight/klausPeterBerger.jpg": 1576,
	"./images/authorSpotlight/lucieGuibault.jpg": 1577,
	"./images/authorSpotlight/manfredWeiss.jpg": 1578,
	"./images/authorSpotlight/michaelHeimert.jpg": 1579,
	"./images/authorSpotlight/nadjaAlexander.jpg": 1580,
	"./images/authorSpotlight/nunoPiresDeCarvalho.jpg": 1581,
	"./images/authorSpotlight/peterChrocziel.jpg": 1582,
	"./images/authorSpotlight/peterFCBegg.jpg": 1583,
	"./images/authorSpotlight/rikTorfs.jpg": 1584,
	"./images/authorSpotlight/ritaDeLaFeria.jpg": 1585,
	"./images/authorSpotlight/robVernout.jpg": 1586,
	"./images/authorSpotlight/russellELevine.jpg": 1587,
	"./images/authorSpotlight/silkeHeinz.jpg": 1588,
	"./images/authorSpotlight/silviaFazio.jpg": 1589,
	"./images/authorSpotlight/steefBartman.jpg": 1590,
	"./images/authorSpotlight/stefaanVanDenBogaert.jpg": 1591,
	"./images/authorSpotlight/stefanKroll.jpg": 1592,
	"./images/authorSpotlight/stefanSchmid.jpg": 1593,
	"./images/authorSpotlight/tugrulAnsay.jpg": 1594,
	"./images/authorSpotlight/verenaVonBomhard.jpg": 1595,
	"./images/authorSpotlight/vincentVerouden.jpg": 1596,
	"./images/authorSpotlight/willemHoyngs.jpg": 1597,
	"./images/authorSpotlight/yvesDerains.jpg": 1598,
	"./images/banner-image-lg.jpeg": 1599,
	"./images/captcha.png": 1600,
	"./images/card code.png": 1601,
	"./images/cart-down.svg": 1602,
	"./images/cart.png": 1603,
	"./images/check.png": 1604,
	"./images/csv.png": 1605,
	"./images/email-mouseover.png": 1606,
	"./images/email.png": 1607,
	"./images/etoc-mouseover.png": 1608,
	"./images/etoc.png": 1609,
	"./images/export-csv-Grey.svg": 1610,
	"./images/export-csv-dafault.svg": 1611,
	"./images/export-csv-default.svg": 1612,
	"./images/facebook.png": 1613,
	"./images/facebook_mouseover.png": 1614,
	"./images/green-arrow.png": 1615,
	"./images/green-tick.svg": 1616,
	"./images/linked_in.png": 1617,
	"./images/linkedin_mousover.png": 1618,
	"./images/login.png": 1619,
	"./images/mastercard.png": 1620,
	"./images/pdf-icon-no-text.svg": 1621,
	"./images/pdf-icon-with-text.svg": 1622,
	"./images/question_mark_mouseover.png": 1623,
	"./images/questionmark_default.png": 1624,
	"./images/rss-mouseover.png": 1625,
	"./images/rss.png": 1626,
	"./images/scopusLogoOrange.svg": 1627,
	"./images/search question - MouseHover.png": 1628,
	"./images/search question.png": 1629,
	"./images/search_button.png": 1630,
	"./images/search_button_Mousehover.png": 1631,
	"./images/search_mouseover.png": 1632,
	"./images/twitter-mouseover.png": 1633,
	"./images/twitter.png": 1634,
	"./images/visa.png": 1635,
	"./images/white-small.svg": 1636,
	"./index.html": 1637,
	"./manifest": 724,
	"./manifest.json": 724,
	"./maxsizeimages/Allissue.PNG": 1638,
	"./maxsizeimages/Arrow-Right.PNG": 1639,
	"./maxsizeimages/Fullissue.PNG": 1640,
	"./maxsizeimages/Home-Help-mousehover.png": 1641,
	"./maxsizeimages/Home-Help.png": 1642,
	"./maxsizeimages/Home-search-mousehover.png": 1643,
	"./maxsizeimages/Home-search.png": 1644,
	"./maxsizeimages/List-Style.PNG": 1645,
	"./maxsizeimages/NextArticle.PNG": 1646,
	"./maxsizeimages/Outlook-WK.jpg": 1647,
	"./maxsizeimages/Plus.PNG": 1648,
	"./maxsizeimages/Rss-Default.png": 1649,
	"./maxsizeimages/Rss-Hover.png": 1650,
	"./maxsizeimages/WK.PNG": 1651,
	"./maxsizeimages/WkFooter.PNG": 1652,
	"./maxsizeimages/ajax-loader.gif": 1653,
	"./maxsizeimages/amex.png": 1654,
	"./maxsizeimages/arrow_down.png": 1655,
	"./maxsizeimages/arrow_up.png": 1656,
	"./maxsizeimages/authorSpotlight/adamLiberman.jpg": 1657,
	"./maxsizeimages/authorSpotlight/alanChristopherNeal.jpg": 1658,
	"./maxsizeimages/authorSpotlight/alastairSutton.jpg": 1659,
	"./maxsizeimages/authorSpotlight/albertJanVanDenBerg.jpg": 1660,
	"./maxsizeimages/authorSpotlight/alexanderRust.jpg": 1661,
	"./maxsizeimages/authorSpotlight/andreAlen.jpg": 1662,
	"./maxsizeimages/authorSpotlight/andreaBiondi.jpg": 1663,
	"./maxsizeimages/authorSpotlight/andreasRZiegler.jpg": 1664,
	"./maxsizeimages/authorSpotlight/author-Esme.png": 1665,
	"./maxsizeimages/authorSpotlight/author-roger.png": 1666,
	"./maxsizeimages/authorSpotlight/author-spot1.png": 1667,
	"./maxsizeimages/authorSpotlight/berntHugenholtz.jpg": 1668,
	"./maxsizeimages/authorSpotlight/bobWessels.jpg": 1669,
	"./maxsizeimages/authorSpotlight/edwinVermulst.jpg": 1670,
	"./maxsizeimages/authorSpotlight/ericSchwartz.jpg": 1671,
	"./maxsizeimages/authorSpotlight/frankEijsvogels.jpg": 1672,
	"./maxsizeimages/authorSpotlight/frankHendrickx.jpg": 1673,
	"./maxsizeimages/authorSpotlight/garyBorn.jpg": 1674,
	"./maxsizeimages/authorSpotlight/jeanFrancoisBelis.jpg": 1675,
	"./maxsizeimages/authorSpotlight/jeffreyLSnyder.jpg": 1676,
	"./maxsizeimages/authorSpotlight/jochenBühling.jpg": 1677,
	"./maxsizeimages/authorSpotlight/johannMuller.jpg": 1678,
	"./maxsizeimages/authorSpotlight/johnBalfour.jpg": 1679,
	"./maxsizeimages/authorSpotlight/jonathanSLux.jpg": 1680,
	"./maxsizeimages/authorSpotlight/klausPeterBerger.jpg": 1681,
	"./maxsizeimages/authorSpotlight/lucieGuibault.jpg": 1682,
	"./maxsizeimages/authorSpotlight/manfredWeiss.jpg": 1683,
	"./maxsizeimages/authorSpotlight/michaelHeimert.jpg": 1684,
	"./maxsizeimages/authorSpotlight/nadjaAlexander.jpg": 1685,
	"./maxsizeimages/authorSpotlight/nunoPiresDeCarvalho.jpg": 1686,
	"./maxsizeimages/authorSpotlight/peterChrocziel.jpg": 1687,
	"./maxsizeimages/authorSpotlight/peterFCBegg.jpg": 1688,
	"./maxsizeimages/authorSpotlight/rikTorfs.jpg": 1689,
	"./maxsizeimages/authorSpotlight/ritaDeLaFeria.jpg": 1690,
	"./maxsizeimages/authorSpotlight/robVernout.jpg": 1691,
	"./maxsizeimages/authorSpotlight/russellELevine.jpg": 1692,
	"./maxsizeimages/authorSpotlight/silkeHeinz.jpg": 1693,
	"./maxsizeimages/authorSpotlight/silviaFazio.jpg": 1694,
	"./maxsizeimages/authorSpotlight/steefBartman.jpg": 1695,
	"./maxsizeimages/authorSpotlight/stefaanVanDenBogaert.jpg": 1696,
	"./maxsizeimages/authorSpotlight/stefanKroll.jpg": 1697,
	"./maxsizeimages/authorSpotlight/stefanSchmid.jpg": 1698,
	"./maxsizeimages/authorSpotlight/tugrulAnsay.jpg": 1699,
	"./maxsizeimages/authorSpotlight/verenaVonBomhard.jpg": 1700,
	"./maxsizeimages/authorSpotlight/vincentVerouden.jpg": 1701,
	"./maxsizeimages/authorSpotlight/willemHoyngs.jpg": 1702,
	"./maxsizeimages/authorSpotlight/yvesDerains.jpg": 1703,
	"./maxsizeimages/banner-image-lg.jpeg": 1704,
	"./maxsizeimages/books/ADR.JPG": 1705,
	"./maxsizeimages/books/AIAJ.jpg": 1706,
	"./maxsizeimages/books/AILA.jpg": 1707,
	"./maxsizeimages/books/AMDM.JPG": 1708,
	"./maxsizeimages/books/ASAB.jpg": 1709,
	"./maxsizeimages/books/BARBIT.JPG": 1710,
	"./maxsizeimages/books/BCDR.jpg": 1711,
	"./maxsizeimages/books/BRA.JPG": 1712,
	"./maxsizeimages/books/BULA.jpg": 1713,
	"./maxsizeimages/books/Banking.png": 1714,
	"./maxsizeimages/books/CAM.jpg": 1715,
	"./maxsizeimages/books/CIVI.jpg": 1716,
	"./maxsizeimages/books/CIVI.png": 1717,
	"./maxsizeimages/books/CMP.jpg": 1718,
	"./maxsizeimages/books/COLA.JPG": 1719,
	"./maxsizeimages/books/COMM.jpg": 1720,
	"./maxsizeimages/books/CONS.jpg": 1721,
	"./maxsizeimages/books/CONT.jpg": 1722,
	"./maxsizeimages/books/CORP.jpg": 1723,
	"./maxsizeimages/books/CRIM.jpg": 1724,
	"./maxsizeimages/books/CYB.jpg": 1725,
	"./maxsizeimages/books/CivilPro.png": 1726,
	"./maxsizeimages/books/Commercial.png": 1727,
	"./maxsizeimages/books/Competition.png": 1728,
	"./maxsizeimages/books/EAL.jpg": 1729,
	"./maxsizeimages/books/ECTA.jpg": 1730,
	"./maxsizeimages/books/ECTAX.jpg": 1731,
	"./maxsizeimages/books/EEELR.jpg": 1732,
	"./maxsizeimages/books/EELR.jpg": 1733,
	"./maxsizeimages/books/EERR.jpg": 1734,
	"./maxsizeimages/books/EFJ.jpg": 1735,
	"./maxsizeimages/books/EICLIT.jpg": 1736,
	"./maxsizeimages/books/ENER.jpg": 1737,
	"./maxsizeimages/books/ENVI.jpg": 1738,
	"./maxsizeimages/books/ERPL.jpg": 1739,
	"./maxsizeimages/books/EUCL.jpg": 1740,
	"./maxsizeimages/books/EUCM.jpg": 1741,
	"./maxsizeimages/books/EULR.jpg": 1742,
	"./maxsizeimages/books/EURO.jpg": 1743,
	"./maxsizeimages/books/Energy-Competition.png": 1744,
	"./maxsizeimages/books/Energy.png": 1745,
	"./maxsizeimages/books/EuCML.jpg": 1746,
	"./maxsizeimages/books/European-Union.png": 1747,
	"./maxsizeimages/books/FAMI.jpg": 1748,
	"./maxsizeimages/books/GPLR.JPG": 1749,
	"./maxsizeimages/books/GTCJ.jpg": 1750,
	"./maxsizeimages/books/IBT.jpg": 1751,
	"./maxsizeimages/books/IEADA.jpg": 1752,
	"./maxsizeimages/books/IELL.jpg": 1753,
	"./maxsizeimages/books/IGO.jpg": 1754,
	"./maxsizeimages/books/IJCL.jpg": 1755,
	"./maxsizeimages/books/ILEL.jpg": 1756,
	"./maxsizeimages/books/INSU.jpg": 1757,
	"./maxsizeimages/books/IPRO.jpg": 1758,
	"./maxsizeimages/books/JOIA.jpg": 1759,
	"./maxsizeimages/books/JournalOfWorldTrade.png": 1760,
	"./maxsizeimages/books/LEIE.jpg": 1761,
	"./maxsizeimages/books/LL_9789065449054.jpg": 1762,
	"./maxsizeimages/books/Latest-update1.png": 1763,
	"./maxsizeimages/books/Law.PNG": 1764,
	"./maxsizeimages/books/MCO.jpg": 1765,
	"./maxsizeimages/books/MEDA.jpg": 1766,
	"./maxsizeimages/books/MEDI.jpg": 1767,
	"./maxsizeimages/books/MIGR.jpg": 1768,
	"./maxsizeimages/books/MLH.PNG": 1769,
	"./maxsizeimages/books/MLH.jpg": 1770,
	"./maxsizeimages/books/MaritimeLaw.PNG": 1771,
	"./maxsizeimages/books/PRIL.jpg": 1772,
	"./maxsizeimages/books/PROP.jpg": 1773,
	"./maxsizeimages/books/RBA.jpg": 1774,
	"./maxsizeimages/books/RELI.jpg": 1775,
	"./maxsizeimages/books/RLVR.JPG": 1776,
	"./maxsizeimages/books/SOCS.jpg": 1777,
	"./maxsizeimages/books/SPORT.jpg": 1778,
	"./maxsizeimages/books/TAXI.jpg": 1779,
	"./maxsizeimages/books/TORT.jpg": 1780,
	"./maxsizeimages/books/TRAD.jpg": 1781,
	"./maxsizeimages/books/TRAN.jpg": 1782,
	"./maxsizeimages/books/Transport-law.png": 1783,
	"./maxsizeimages/books/WOCO.jpg": 1784,
	"./maxsizeimages/books/WTAM.jpg": 1785,
	"./maxsizeimages/books/author-Esme.png": 1786,
	"./maxsizeimages/books/author-roger.png": 1787,
	"./maxsizeimages/books/author-spot1.png": 1788,
	"./maxsizeimages/books/blank.png": 1789,
	"./maxsizeimages/books/common-market-law.png": 1790,
	"./maxsizeimages/books/corporate.PNG": 1791,
	"./maxsizeimages/books/corporatecomm.PNG": 1792,
	"./maxsizeimages/books/encyclopedia.PNG": 1793,
	"./maxsizeimages/books/transport.png": 1794,
	"./maxsizeimages/card code.png": 1795,
	"./maxsizeimages/cart.png": 1796,
	"./maxsizeimages/check.png": 1797,
	"./maxsizeimages/csv.png": 1798,
	"./maxsizeimages/email-mouseover.png": 1799,
	"./maxsizeimages/email.png": 1800,
	"./maxsizeimages/etoc-mouseover.png": 1801,
	"./maxsizeimages/etoc.png": 1802,
	"./maxsizeimages/facebook.png": 1803,
	"./maxsizeimages/facebook_mouseover.png": 1804,
	"./maxsizeimages/green-arrow.png": 1805,
	"./maxsizeimages/linked_in.png": 1806,
	"./maxsizeimages/linkedin_mousover.png": 1807,
	"./maxsizeimages/login.png": 1808,
	"./maxsizeimages/mastercard.png": 1809,
	"./maxsizeimages/pdf-icon-no-text.svg": 1810,
	"./maxsizeimages/pdf-icon-with-text.svg": 1811,
	"./maxsizeimages/question_mark_mouseover.png": 1812,
	"./maxsizeimages/questionmark_default.png": 1813,
	"./maxsizeimages/rss-mouseover.png": 1814,
	"./maxsizeimages/rss.png": 1815,
	"./maxsizeimages/search question - MouseHover.png": 1816,
	"./maxsizeimages/search question.png": 1817,
	"./maxsizeimages/search_button.png": 1818,
	"./maxsizeimages/search_button_Mousehover.png": 1819,
	"./maxsizeimages/search_mouseover.png": 1820,
	"./maxsizeimages/twitter-mouseover.png": 1821,
	"./maxsizeimages/twitter.png": 1822,
	"./maxsizeimages/visa.png": 1823,
	"./siqpagetag": 725,
	"./siqpagetag.js": 725,
	"./subscriber_journals.xml": 1824,
	"./subscribers.xml": 1825
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 422;


//////////////////
// WEBPACK FOOTER
// ./public ^\.\/.*$
// module id = 422
// module chunks = 1